import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { Clock } from 'lucide-react';
import FavoriteHeart from '@/components/FavoriteHeart';
import SmartImage from '@/components/SmartImage';

export const HackCard = ({ hack }) => {
  return (
    <Link
      to={`/diy/${hack.slug}`}
      data-testid="hack-card"
      data-hack-id={hack.id}
      className="group block"
    >
      <Card className="card-hover overflow-hidden bg-card border-border/70 rounded-2xl shadow-[0_8px_24px_rgba(31,26,23,0.05)]">
        <div className="relative">
          <AspectRatio ratio={3 / 2}>
            <SmartImage
              src={hack.image_url}
              alt={hack.name}
              fallbackKind="hack"
              className="h-full w-full object-cover"
            />
          </AspectRatio>
          <div className="absolute top-3 right-3">
            <FavoriteHeart
              type="hack"
              id={hack.id}
              testId={`hack-favorite-toggle-${hack.id}`}
            />
          </div>
          <div className="absolute bottom-3 left-3 flex flex-wrap gap-1.5">
            {(hack.skin_types || []).slice(0, 2).map((s) => (
              <Badge
                key={s}
                variant="secondary"
                className="bg-card/90 backdrop-blur text-foreground border border-border/70 text-[10px] uppercase tracking-[0.14em] font-medium"
              >
                {s}
              </Badge>
            ))}
          </div>
        </div>
        <div className="p-4 sm:p-5">
          <h3 className="font-display text-xl font-semibold leading-tight text-ink">
            {hack.name}
          </h3>
          <p className="mt-1.5 text-sm text-muted-foreground line-clamp-2 leading-relaxed">
            {hack.excerpt}
          </p>
          <div className="mt-4 flex items-center justify-between">
            <div className="flex flex-wrap gap-1.5">
              {(hack.benefits || []).slice(0, 2).map((b) => (
                <span
                  key={b}
                  className="text-[11px] tracking-[0.04em] text-rose-gold border border-rose-tint bg-accent/40 rounded-full px-2 py-0.5"
                >
                  {b}
                </span>
              ))}
            </div>
            <span className="flex items-center gap-1 text-xs text-muted-foreground">
              <Clock className="h-3 w-3" /> {hack.prep_time}
            </span>
          </div>
        </div>
      </Card>
    </Link>
  );
};

export default HackCard;
